/**
 *  weiboAttentionModule
 *
 * Description 关注的微博
 * author: Qian.qianchen 2018-11-22
 */
'use strict';
angular.module('weiboAttentionModule', ['weiboAttentionRouterModule']).controller('weiboAttentionCtrl', [
    '$scope',
    '$stateParams',
    'editingCenterWeiBoService',
    '$q',
    'trsHttpService',
    'modalDialog',
    '$validation',
    '$timeout',
    'editcenterRightsService',
    'weiboApiParams',
    'weiboApiService',
    function(
        $scope,
        $stateParams,
        editingCenterWeiBoService,
        $q,
        trsHttpService,
        modalDialog,
        $validation,
        $timeout,
        editcenterRightsService,
        weiboApiParams,
        weiboApiService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 15,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                user: {},
                commentPage: {
                    CURRPAGE: 1,
                    PAGESIZE: 15,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                },
                hasRight: true,
                fromdate: '',
                untildate: ''
            };
            $scope.data = {
                items: [],
            };
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            initBtnRights();
            requestData().then(function() {
                return getWeiboUser();
            });
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeiboListBtn('microblog.guanzhudeweibo', $stateParams.wbchannelid).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            let params = angular.extend({}, weiboApiParams.homeTimeLineParams, {
                PageIndex: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                AccountId: $stateParams.wbchannelid,
            });
            $scope.loadingPromise = weiboApiService.getHomeTimeLine(params).then(
                function(data) {
                    $scope.status.hasRight = true;
                    $scope.data.items = data.result;
                    if (!!data.pageinfo) {
                        $scope.page.CURRPAGE = data.pageinfo.indexPage;
                        $scope.page.PAGESIZE = data.pageinfo.pageSize;
                        $scope.page.ITEMCOUNT = data.pageinfo.totalNum;
                        $scope.page.PAGECOUNT = data.pageinfo.pageCount;
                    } else {
                        $scope.page.ITEMCOUNT = '0';
                    }
                    deferred.resolve(data);
                },
                function(data) {
                    $scope.status.hasRight = false;
                }
            );
            return deferred.promise;
        }

        /**
         * [getWeiboUser description] 获取当前登录的微博账户信息
         * @return {[type]} [description]
         */
        function getWeiboUser() {
            var deferred = $q.defer();
            var params = {
                serviceid: 'wcm61_scmaccount',
                methodname: 'findByIdToJson',
                ObjectId: $stateParams.wbchannelid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.status.user = data.DATA;
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [addEmoji description]
         *
         * @param   {[type]}  item     [item description]
         * @param   {[type]}  dom      [dom description]
         * @param   {[type]}  attr     [attr description]
         * @param   {[type]}  dataObj  [dataObj description]
         *
         * @return  {[type]}           [return description]
         */
        function addEmoji(item, dom, attr, dataObj) {
            var startPos = dom.selectionStart;
            var endPos = dom.selectionEnd;
            dataObj = attr == 'retweeted' ? dataObj.retweetedMicroContent : dataObj;
            dataObj.commentContent =
                dataObj.commentContent.substring(0, startPos) + item.value + dataObj.commentContent.substring(endPos, dataObj.commentContent.length);

            $timeout(function() {
                dom.focus();
                dom.selectionStart = dom.selectionEnd = startPos + item.value.length;
            });
        }

        /**
         * [pageChanged description] 换页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [timeSelect description] 时间筛选
         * @return {[type]} [description]
         */
        $scope.timeSelect = function() {
            requestData();
        };

        /**
         * [headPicload description] 头像未能正常显示时显示默认头像
         * @param  {[object]} item [description] 微博账号对象
         * @return {[type]}      [description]
         */
        $scope.headPicload = function(item, attr) {
            var imgObj = new Image();
            if (attr == 'user.head') {
                imgObj.src = item.user.head;
            } else if (attr == 'head') {
                imgObj.src = item.head;
            }

            imgObj.onload = function() {
                item.picUrl = imgObj.src;
            };
            imgObj.onerror = function() {
                item.picUrl = './images/user_icon.jpg';
            };
        };

        /**
         * [retweetedUserFormat description] 转载微博作者
         * @param  {[String]} name [description] 原作者名
         * @return {[type]}      [description]
         */
        $scope.retweetedUserFormat = function(name) {
            return '@' + name;
        };


        /**
         * [itemCommentInit description] 评论区域是否显示初始化
         * @param  {[Object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
        $scope.itemCommentInit = function(item, type, index) {
            item.commentShow = false;
            item.emojiShow = false;
            item.commentContent = '';
            item.commentPage = {
                CURRPAGE: 1,
                PAGESIZE: 5,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            item.formName =
                type == 'origin'
                    ? 'attentionOriginForm' + (index + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE)
                    : 'attentionRetweetedForm' + (index + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE);
        };

        /**
         * [commentToggle description] 点击评论显示/隐藏
         * @param  {[object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
        $scope.commentToggle = function(item, $event) {
            $event.stopPropagation();
            item.commentContent = '';
            if (!item.commentShow) {
                $scope.commentWeibo(item, status);
            }
            item.commentShow = !item.commentShow;
        };

        /**
         * [commentWeibo description] 获取微博下的所有评论
         * @param  {[Object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
        $scope.commentWeibo = function(item) {
            var params = {
                serviceid: 'wcm61_scmcomment',
                methodname: 'queryCommentsByMCIdToJson',
                MicroContentId: item.id,
                AccountId: $stateParams.wbchannelid,
                PageIndex: item.commentPage.CURRPAGE,
                PageSize: item.commentPage.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                item.comments = data.result;
                item.commentPage.CURRPAGE = data.pageinfo.indexPage;
                item.commentPage.PAGESIZE = data.pageinfo.pageSize;
                item.commentPage.ITEMCOUNT = data.pageinfo.totalNum;
                item.commentPage.PAGECOUNT = data.pageinfo.pageCount;
            });
        };

        /**
         * [commentSubmit description] 微博评论
         * @param  {[String]} name   [description] 评论name字符
         * @param  {[Int]} index   [description] 下标
         * @return {[type]}        [description]
         */
        $scope.commentSubmit = function(item, name, index) {
            var formName = name + '_' + (index + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE);
            $validation.validate($scope.commentForm[formName]).success(function() {
                var params = {
                    serviceid: 'wcm61_scmcomment',
                    methodname: 'createCommentToJson',
                    MicroContentId: item.id,
                    AccountId: $stateParams.wbchannelid,
                    isReplyComment: false,
                    Content: item.commentContent,
                    modulename: 'microblog.guanzhudeweibo.pinglun',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWeiboRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('评论成功', '', 'success', false);
                    item.commentContent = '';
                    item.commentCount++;
                    $scope.commentWeibo(item);
                    item.commentShow = true;
                });
            });
        };

        /**
         * [forwardWeibo description] 微博转发
         * @param  {[object]} item [description] 微博item
         * @return {[type]}      [description]
         */
        $scope.forwardWeibo = function(item) {
            editingCenterWeiBoService.repostWeibo(item, 'microblog.guanzhudeweibo.zhuanfa', function(result) {
                if (result == 'success') {
                    modalDialog.alertType('微博转发成功', '', 'success', false);
                } else if (result == 'successTimeRepost') {
                    modalDialog.alertType('微博定时转发成功', '', 'success', false);
                }
            });
        };

        /**
         * [addOriginEmoji description] 原创微博添加表情
         * @param {[object]} item [description] 表情对象
         */
        $scope.addOriginEmoji = function(item, dataObj) {
            var dom = document.getElementById('origin_input_content');
            addEmoji(item, dom, 'commentContent', dataObj);
        };

        /**
         * [addRetweetedEmoji description] 转发微博添加表情
         * @param {[object]} item [description] 表情对象
         */
        $scope.addRetweetedEmoji = function(item, dataObj) {
            var dom = document.getElementById('retweeted_input_content');
            addEmoji(item, dom, 'retweeted', dataObj);
        };
    },
]);
